//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { handleSecureAjaxError } from "../utils/SecurePlatformAPIUtils";
import { getGraphQLClient } from "../clients/GraphQLClient";
import { GET_USER_INBOX, getTasksList } from "./queries/UserInboxQueries";
export const fetchUserTasks = (filters, callback) => {
  const log = pilog.getLogger("UserInboxActions fetchUserTasks");
  const graphQLClient = getGraphQLClient();
  const {
    query,
    variables
  } = getTasksList(filters);
  graphQLClient.query({
    query,
    variables: {
      filter: variables
    },
    fetchPolicy: "no-cache"
  }).then(response => {
    const inboxTaskRecords = response.data.getTasks.tasks;
    if (inboxTaskRecords) {
      const inbox = processUserInbox(inboxTaskRecords);
      callback(inbox, response.data.getTasks);
    } else {
      log.error("Could not find users Tasks");
      callback({
        hasError: true
      });
    }
  }).catch(error => {
    handleSecureAjaxError(error, "UserInboxActions fetchUserTasks");
    callback({
      hasError: true,
      error
    });
  });
};
export const fetchUserInbox = (filters, callback) => {
  const log = pilog.getLogger("UserInboxActions fetchUserInbox");
  const graphQLClient = getGraphQLClient();
  graphQLClient.query({
    query: GET_USER_INBOX,
    variables: {
      filter: filters.fetchPass ? "pass" : "none"
    },
    fetchPolicy: "no-cache"
  }).then(response => {
    const inboxRecords = response.data.getInbox;
    if (inboxRecords) {
      const inbox = processUserInbox(inboxRecords);
      callback(inbox);
    } else {
      log.error("Could not find users inbox");
      callback({
        hasError: true
      });
    }
  }).catch(error => {
    handleSecureAjaxError(error, "UserInboxActions fetchUserInbox");
    callback({
      hasError: true,
      error
    });
  });
};

/**
 * Remap to object so it's easier to manipulate
 *
 * Removes expired messages
 * Adds the "claimedByAnother" flag, used to show the locak animation
 *
 * @param {array} inboxRecords
 */
const processUserInbox = inboxRecords => {
  const currentTime = new Date().getTime();
  const inbox = {};
  inboxRecords.map(message => {
    if (!message.expired || message.expires < currentTime) {
      message.claimedByAnother = false;
      inbox[message.messageId] = message;
    }
    if (!message.type) {
      message.type = "missing";
    }
  });
  return inbox;
};